<div class="row">
  <div class="col-sm-12 col-lg-4 form-group">
    <input type="text" placeholder="Fecha de Inicio" class="form-control" bsDatepicker
      [bsConfig]="{ adaptivePosition: true, dateInputFormat: 'DD/MM/YYYY', showWeekNumbers: false }"
      [(bsValue)]="fechaInicio" [maxDate]="fechaFin" [minDate]="minFechaInicio" readonly>
  </div>
  <div class="col-sm-12 col-lg-4 form-group">
    <input type="text" placeholder="Fecha Fin" class="form-control" bsDatepicker
      [bsConfig]="{ adaptivePosition: true, dateInputFormat: 'DD/MM/YYYY', showWeekNumbers: false}"
      [(bsValue)]="fechaFin" [minDate]="fechaInicio" readonly>
  </div>
  <div class="col-sm-12 col-lg-4 d-flex justify-content-start align-items-end">
    <button type="button" class="btn btn-outline-primary d-flex align-items-center mb-4" (click)="ObtenerMovimientos()">
      <span class="material-icons">search</span>
      Buscar
    </button>
  </div>
  <div class="col-12">
    <div class="table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th scope="col" class="text-uppercase text-left">Fecha</th>
            <th scope="col" class="text-uppercase text-center">Documento</th>
            <th scope="col" class="text-uppercase text-center">Transacción</th>
            <th scope="col" class="text-uppercase text-right">Valor</th>
            <th scope="col" class="text-uppercase text-left">Fecha</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="movimientos?.length === 0">
            <td colspan="5" class="text-uppercase text-center">No hay información para mostrar</td>
          </tr>
          <tr *ngFor="let movimiento of movimientos">
            <td class="text-left">{{movimiento?.fecha | date: 'dd/MM/yyyy'}}</td>
            <td class="text-center">{{movimiento?.documento}}</td>
            <td class="text-center">{{movimiento?.transaccion}}</td>
            <td class="text-right">{{movimiento?.valor | currency}}</td>
            <td class="text-left">{{movimiento?.fecha| date: 'dd/MM/yyyy'}}</td>
          </tr>
        </tbody>
      </table>

      <div class="d-flex justify-content-between p-2">
        <ngb-pagination [collectionSize]="cantidad" [(page)]="pagina" [pageSize]="paginaTamanio" [rotate]="true"
          [maxSize]="5" [boundaryLinks]="true" (pageChange)="ListarMovimientos()">
        </ngb-pagination>

        <select class="custom-select" style="width: auto" [(ngModel)]="paginaTamanio"
          (ngModelChange)="ListarMovimientos()">
          <option [ngValue]="3">3 movimientos por página</option>
          <option [ngValue]="5">5 movimientos por página</option>
          <option [ngValue]="10">10 movimientos por página</option>
        </select>
      </div>
    </div>
  </div>
</div>
